/* eslint-disable @typescript-eslint/no-explicit-any */

import IBiuroSzczegoly from '~/components/biura/types/IBiuroSzczegoly';
import IGoogleMapPosition from '~/components/map/types/IGoogleMapPosition';
import IMapBiuroSzczegolyServiceConfig from '~/components/map/types/IMapBiuroSzczegolyServiceConfig';
import IMarkerIcon from '~/components/map/types/marker/IMarkerIcon';

import addEventListenerToMapFullyLoaded from '../../event-listeners/addEventListenerToMapFullyLoaded';
import setZoom from '../../shared/setZoom';

const getMapFunctions = ({ mapRef, config, markerIcon }: IMapBiuroSzczegolyServiceConfig) => ({
  buildCluster: (): object => ({}),
  getMarkerZIndex: (): number => 1000001,
  buildMarkerSvg: (): IMarkerIcon => markerIcon,
  getMarkerPosition(marker: IBiuroSzczegoly): IGoogleMapPosition {
    return { lat: marker.SzerokoscGeo, lng: marker.DlugoscGeo };
  },
  calculator(): object {
    return {};
  },
  setZoom(value: number) {
    return setZoom({ config, mapRef } as IMapBiuroSzczegolyServiceConfig, value);
  },
  markerClicked: (): void => {},
  mapIsFullyLoadedAndStreetViewIsUnvisible: (): boolean => config.isFullyLoaded && !config.streetViewIsVisible,

  init: async (serviceConfig: IMapBiuroSzczegolyServiceConfig): Promise<void> => {
    if (!mapRef?.value) return;

    addEventListenerToMapFullyLoaded({ serviceConfig, gmap: await mapRef.value.$mapPromise });
  },
});

export default getMapFunctions;
